import Toast from './toast'
const obj = {}
obj.install = function (Vue) {
  const toastContrustor = Vue.extend(Toast)
  const toast = new toastContrustor()
  toast.$mount(document.createElement('div'))
  document.body.appendChild(toast.$el)
  Vue.prototype.$toastUtil = toast
}

export default obj
